import styles from './Badge.module.scss'

interface BadgeProps {
  mint?: boolean
  value: number | string
}

const Badge = ({ mint = false, value }: BadgeProps) => (
  <div className={[styles.badge, mint ? styles.mint : undefined].join(' ')} data-testid="badge">
    {value}
  </div>
)

export default Badge
